<div class="alerts" *ngIf=" canView && alerts && alerts.length > 0">
  <h3>Solicitudes Pendientes</h3>

  <div class="alert-item" *ngFor="let item of alerts" [ngClass]="item.type">
    <span class="alert-icon material-icons">error</span>
    <div class="alert-content">
      <strong *ngIf="item.message">{{ item.message }}</strong>
    </div>
  </div>
</div>
